/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_ParentInputs */

const cs_office_parent = /** @type {(inputs: Office_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mateřská organizace`)
};

const en_office_parent = /** @type {(inputs: Office_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent organization`)
};

/**
* | output |
* | --- |
* | "Parent organization" |
*
* @param {Office_ParentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_parent = /** @type {((inputs?: Office_ParentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_ParentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_parent(inputs)
	return cs_office_parent(inputs)
});